import React from 'react'
import OutlinedInput from '@mui/material/OutlinedInput';
import InputAdornment from '@mui/material/InputAdornment';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import CustomTheme from './CustomTheme';
import InputUnstyled from '@mui/base/InputUnstyled';
import { styled } from '@mui/system';


const blue = {
    100: '#DAECFF',
    200: '#80BFFF',
    400: '#3399FF',
    600: '#0072E5',
  };
  
  const grey = {
    50: '#F3F6F9',
    100: '#E7EBF0',
    200: '#E0E3E7',
    300: '#CDD2D7',
    400: '#B2BAC2',
    500: '#A0AAB4',
    600: '#6F7E8C',
    700: '#3E5060',
    800: '#2D3843',
    900: '#1A2027',
  };
  
  const StyledInputElement = styled('input')(
    ({ theme }) => `
    width: 100%;
    color: ${theme.palette.mode === 'dark' ? grey[300] : '#528586'};
    background: ${theme.palette.mode === 'dark' ? grey[900] : '#f8f8f8'};
    border: 1px solid ${theme.palette.mode === 'dark' ? grey[800] : '#528586'};
    border-radius: 8px;
    margin-top: auto;
    margin-bottom: auto;

    padding: 8px;
    
    &:hover {
      background: ${theme.palette.mode === 'dark' ? '' : '#E8F1F1'};
      border-color: ${theme.palette.mode === 'dark' ? grey[700] : grey[400]};
    }
  
    &:focus {
      outline: 3px solid ${theme.palette.mode === 'dark' ? blue[600] : '#E8F1F1'};
    }
  `,
  )

//   width: 320px;
//   font-size: 0.875rem;
//   font-family: IBM Plex Sans, sans-serif;
//   font-weight: 400;
//   line-height: 1.5;

const MessengerInput = React.forwardRef(function MessengerInput(props, ref) {
    return (
      <InputUnstyled style={{
          width: '100%'
      }} components={{ Input: StyledInputElement }} {...props} ref={ref} />
    );
})

// const MessengerInput = (props) => (
//     <CustomTheme>
//     <FormControl sx={{...props.sx}} variant="outlined">
//         <OutlinedInput
//             id="outlined-message-input"
//             value={props.inputValue}
//             onChange={e => props.handleChange(e)}
//             // endAdornment={<InputAdornment position="end">kg</InputAdornment>}
//             // aria-describedby="outlined-message-input-helper-text"
//             // inputProps={{
//             //     'aria-label': props.ariaLabel,
//             // }}
//         />
//         {/*<FormHelperText id="outlined-message-input-helper-text">{props.helpderText}</FormHelperText>*/}
//     </FormControl>
//     </CustomTheme>
// )

export { MessengerInput }